import { QueryFactory } from "../../../../Common";
export const QGetSports = QueryFactory("GetSports");
//# sourceMappingURL=QGetSports.js.map